module.exports = __webpack_public_path__ + "img/hr-burner-mining-drill-S.a4332f96.png";